
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group"}},[_c('path',{attrs:{"data-name":"Path","d":"M26.8 88.7H67a12 12 0 0012-12V46.5a2 2 0 00-4 0v30.2a8 8 0 01-8 8H26.8a8 8 0 01-8-8V27.5a8 8 0 018-8H51a2 2 0 100-4H26.8a12 12 0 00-12 12v49.2a12 12 0 0012 12z"}}),_c('path',{attrs:{"data-name":"Compound Path","d":"M82.7 13.8a8.6 8.6 0 00-12.1 0l-28 28a2 2 0 00-.5.8l-4.8 14.1a2 2 0 001.9 2.6h.6l14.1-4.8.8-.5 28-28a8.6 8.6 0 000-12.1zm-2.8 9.3L52.2 50.8l-9.8 3.4 3.4-9.8 27.6-27.8a4.6 4.6 0 016.4 6.4z"}})])])
          )
        }
      }
    